export default __webpack_public_path__ + "static/media/prike.1c4b93d0.svg";